import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Header = styled.header`
	display: flex;
	flex-direction: column;
	gap: 30px;
	margin: 30px 20px;
`;

export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

export const FlexRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const Main = styled.main`
	height: calc(100vh - 138px - 94px - 90px);
	margin: 30px 20px;
`;

export const Footer = styled.footer`
	display: flex;
	align-items: center;
	gap: 20px;
	background-color: ${tokens.color_gray_light};
	padding: 30px 20px;

	button {
		font-weight: 600;
	}
`;

export const ItemWrapper = styled.div<{ gap?: string }>`
	display: flex;
	flex-direction: column;
	gap: ${({ gap }) => gap || '30px'};
`;
